module.exports = __webpack_public_path__ + "static/commercial-services-1b10e548cd99fbd8d5796698eb139ef2.png";